module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý đối soát"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        _vm.isOpenDialogCompare = true
      }
    }
  }, [_vm._v("Thêm mới đối soát")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.crossCheckTable,
    attrs: {
      "table-name": _vm.crossCheckTable,
      "data-source": "cross-checks",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.crossCheckTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.crossCheckTable].current_page - 1) *
                  _vm.dataPaginations[_vm.crossCheckTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đối Soát",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.id) ? _c('p', [_c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.id))])]) : _vm._e(), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_vm._v(_vm._s(scope.row.created_at))])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-grey"
              }, [_c('p', [_c('span', [_vm._v("Ngày đối soát:")]), _vm._v(" " + _vm._s(scope.row.created_at))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Kiểu đối soát:")]), _vm._v(" "), _c('el-tag', {
                attrs: {
                  "size": "small",
                  "type": _vm.kindStatus(scope.row.kind)
                }
              }, [_vm._v(_vm._s(scope.row.kind_txt))])], 1)])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Ghi chú"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-grey"
              }, [(scope.row.note) ? _c('p', [_vm._v(_vm._s(scope.row.note))]) : _vm._e()])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đơn Hàng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-grey"
              }, [_c('p', [_c('span', [_vm._v("Thành công:")]), _vm._v(" "), _c('span', {
                staticClass: "text-green"
              }, [_vm._v(_vm._s(scope.row.num_compare_success))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Lỗi:")]), _vm._v(" "), _c('span', {
                staticClass: "text-orange"
              }, [_vm._v(_vm._s(scope.row.num_compare_error))])])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tổng COD thu"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-grey"
              }, [_c('p', [_c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.cod_carrier)))])])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Trạng Thái"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [_c('p', [_c('span', {
                class: _vm.compareStatuses[scope.row.status]
              }, [_vm._v(_vm._s(scope.row.status_txt))])])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "110",
            "label": "Thao Tác",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Chi tiết đối soát"
                }
              }, [_c('router-link', {
                staticClass: "text-grey padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'listting-compare',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "el-icon-view"
              })])], 1), _vm._v(" "), (!scope.row.status) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xác nhận đối soát"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-check"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.confirmApplyCompare(scope.row)
                  }
                }
              })], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xuất bảng kê"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-download"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.exportExcelComapre(scope.row)
                  }
                }
              })], 1), _vm._v(" "), _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa ghi chú đối soát"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.editNoteCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "el-icon-edit"
              })])], 1), _vm._v(" "), (!scope.row.status) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Hủy đối soát"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.removeCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "el-icon-remove text-red"
              })])], 1) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "size": "small",
      "type": "daterange",
      "range-separator": "/",
      "format": "dd-MM-yyyy",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.filterDateRange),
      callback: function($$v) {
        _vm.filterDateRange = $$v
      },
      expression: "filterDateRange"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "size": "small",
      "filterable": "",
      "clearable": "",
      "placeholder": "Kiểu đối soát"
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.kind),
      callback: function($$v) {
        _vm.$set(_vm.filters, "kind", $$v)
      },
      expression: "filters.kind"
    }
  }, _vm._l((_vm.crossChecksHelpers.kinds), function(kindName, kindKey) {
    return _c('el-option', {
      key: kindKey,
      attrs: {
        "label": kindName,
        "value": kindKey
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.crossChecksHelpers.statuses) ? _c('el-radio-group', {
    staticClass: "status-listting",
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, [_vm._l((_vm.crossChecksHelpers.statuses), function(status, index) {
    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_vm._v("\n                " + _vm._s(status) + "\n              ")])
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": -1
    }
  }, [_c('span', [_vm._v("Tất cả")])])], 2) : _vm._e()], 1)], 1)], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isOpenDialogCompare,
      "title": "Tạo đối soát",
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.isOpenDialogCompare = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "dialog-footer"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.isOpenDialogCompare = false
            }
          }
        }, [_vm._v("Thoát")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.importNewCompare()
            }
          }
        }, [_vm._v("\n          Tạo mới\n        ")])], 1)]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "padding-sm-bottom"
  }, [_c('span', [_vm._v("Bạn chắc chắn muốn tạo mới đối soát loại nào")]), _vm._v(" "), _c('el-radio-group', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.kindCrossCheck),
      callback: function($$v) {
        _vm.kindCrossCheck = $$v
      },
      expression: "kindCrossCheck"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("Cod")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("Phí")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("Phí lần 2")])], 1)], 1), _vm._v(" "), _c('h4', {
    staticClass: "margin-bottom margin-top"
  }, [_vm._v("Ghi chú")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Nhập ghi chú",
      "maxlength": "255",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.note),
      callback: function($$v) {
        _vm.note = $$v
      },
      expression: "note"
    }
  }), _vm._v(" "), (_vm.kindCrossCheck !== 1) ? [_c('h4', {
    staticClass: "margin-bottom margin-top"
  }, [_vm._v("Tháng đối soát")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "type": "month",
      "placeholder": "Chọn tháng"
    },
    model: {
      value: (_vm.monthRangeVal),
      callback: function($$v) {
        _vm.monthRangeVal = $$v
      },
      expression: "monthRangeVal"
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isOpenDialogEditNote,
      "title": "Sửa ghi chú đối soát",
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.isOpenDialogEditNote = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "dialog-footer"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.isOpenDialogEditNote = false
            }
          }
        }, [_vm._v("Thoát")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handlerEditNote()
            }
          }
        }, [_vm._v("\n          Xác nhận\n        ")])], 1)]
      },
      proxy: true
    }])
  }, [_c('h4', {
    staticClass: "margin-bottom margin-top"
  }, [_vm._v("Ghi chú")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Nhập ghi chú",
      "maxlength": "255",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.noteEdit),
      callback: function($$v) {
        _vm.noteEdit = $$v
      },
      expression: "noteEdit"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-775b2c2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compare/Compare.vue
// module id = 648
// module chunks = 1